import { Pipe, PipeTransform } from '@angular/core';
import { UsersFilterOptions } from './user-with-monthly-closures-status-filter.component';

@Pipe({
  name: 'selectedFilter',
})
export class SelectedFilterPipe implements PipeTransform {
  transform(
    selected: { nzValue: string },
    users: UsersFilterOptions[] | null,
  ): UsersFilterOptions | undefined {
    return users?.find((user) => user.id === selected.nzValue);
  }
}
